module.exports = __webpack_public_path__ + "static/media/background1.12181f2e.jpg";